import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import CarrierM39ComplianceReport from '../../components/CarrierM39ComplianceReport';
import {
  getPercentageColumns,
  getNumberColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/CarrierM39ComplianceOperatorSelectors';
import CarrierM39ComplianceOperatorReportMode from './CarrierM39ComplianceOperatorReportMode';

const MODE_TABS = [
  { value: CarrierM39ComplianceOperatorReportMode.percentage, label: '%' },
  { value: CarrierM39ComplianceOperatorReportMode.number, label: '#' },
];

export class CarrierM39ComplianceOperatorContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportMode: CarrierM39ComplianceOperatorReportMode.percentage,
    };
  }

  changeMode = reportMode => this.setState({ reportMode });

  renderPercentage() {
    return (
      <CarrierM39ComplianceReport
        reportId={ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_OPERATOR.id}
        columns={this.props.percentageColumns}
        isLoading={this.props.isLoading}
        generatedOnDateTime={this.props.generatedDateTime}
        data={this.props.data}
        modeTabs={MODE_TABS}
        changeMode={this.changeMode}
        mode={CarrierM39ComplianceOperatorReportMode.percentage}
      />
    );
  }

  renderNumber() {
    return (
      <CarrierM39ComplianceReport
        reportId={ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_OPERATOR.id}
        columns={this.props.numberColumns}
        isLoading={this.props.isLoading}
        generatedOnDateTime={this.props.generatedDateTime}
        data={this.props.data}
        modeTabs={MODE_TABS}
        changeMode={this.changeMode}
        mode={CarrierM39ComplianceOperatorReportMode.number}
      />
    );
  }

  render() {
    switch (this.state.reportMode) {
      case CarrierM39ComplianceOperatorReportMode.percentage:
        return this.renderPercentage();
      case CarrierM39ComplianceOperatorReportMode.number:
        return this.renderNumber();
      default:
        return (<div id="report-mode-error">Report mode &quot;{this.state.reportMode}&quot; is not implemented</div>);
    }
  }
}
function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    percentageColumns: getPercentageColumns(state),
    numberColumns: getNumberColumns(state),
  };
}

CarrierM39ComplianceOperatorContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  percentageColumns: PropTypes.arrayOf(PropTypes.object),
  numberColumns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(CarrierM39ComplianceOperatorContainer);

